import type { JSX } from 'react'

import {
  ChannelProgramRowsSkeletonSC,
  ChannelProgramRowSkeletonBlockSC,
  ChannelProgramRowSkeletonSC,
} from '../ProgramList.styled'

export interface IChannelProgramRowsSkeleton {
  rowsCount?: number
}

export const ChannelProgramRowsSkeleton = ({
  rowsCount = 6,
}: IChannelProgramRowsSkeleton): JSX.Element => (
  <ChannelProgramRowsSkeletonSC>
    {new Array(rowsCount).fill(null).map((_, index) => (
      <ChannelProgramRowSkeletonSC key={index}>
        <ChannelProgramRowSkeletonBlockSC variant='channel' />
        <ChannelProgramRowSkeletonBlockSC variant='program' />
      </ChannelProgramRowSkeletonSC>
    ))}
  </ChannelProgramRowsSkeletonSC>
)

export const ChannelProgramsSkeleton = (): JSX.Element => (
  <ChannelProgramRowSkeletonBlockSC variant='program' />
)
